import React, { useEffect } from 'react'
import LanguageStrings from '../../../../i18n/locales'
// import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Modal from '@mui/material/Modal'
import { connect, type ConnectedProps, useDispatch } from 'react-redux'
import { type RootState } from '../../../../store'
import { fetchSiteInfo } from '../../redux/actionCreators'
import { type SiteInfoState } from '../../redux/siteInfoSlice'
import { Button } from '../../../../components/Button'
import HierarchyView from './HierarchyView'
import { siteInfoReset } from '../../redux/siteInfoSlice'
import './ViewSite.css'

const ViewSiteStrings = LanguageStrings().SiteManagementCollectionStrings.TableComponent

const successModalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '45%',
  bgcolor: '#272727',
  fontFamily: 'Honeywell Sans Web',
  p: 2,
  height: 'calc(75% - 40px)'
}
interface ParentProps {
  siteId: string
  viewSitePopup: (val: string) => void
}

const ViewSite = (props: AllProps): JSX.Element => {
  const dispatch = useDispatch()
  useEffect(() => {
    props?.fetchSiteInfo(props.siteId)
  }, [props.siteId])

  useEffect(() => {
    return () => {
      dispatch(siteInfoReset())
    }
  }, [])

  const handleClose = (event: MouseEvent, reason: 'backdropClick' | 'escapeKeyDown'): void => {
    // istanbul ignore next
    if (reason !== 'backdropClick') {
      props.viewSitePopup('')
    }
  }
  return (
    <Modal className="view-site-modal" open={props.siteId !== ''} onClose={handleClose} disableEscapeKeyDown={true}>
      <Box sx={successModalStyle}>
        <Grid container className="view-site-grid" sx={{ display: 'flex' }} >
          <Grid item xs={12} className='view-site-heading'>
            <p>{ViewSiteStrings.HierarchyView}</p>
          </Grid>
          {/* <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <CloseIcon data-testid="close-icon" className="view-site-close-icon" onClick={() => { props.viewSitePopup('') }} />
          </Grid> */}
        </Grid>
        <HierarchyView site={props?.siteInfo?.siteInfo?.hierarchyStructure?.site} id={props.siteId} />
        <Grid container>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'end', bottom: '15px', right: '10px', position: 'absolute' }}>
            <Button type='hollow' className='view-close-btn' dataTestId="close-btn-click" onClick={() => { props.viewSitePopup('') }}>
              {ViewSiteStrings.Close}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}

interface DispatchToProps {
  fetchSiteInfo: (siteId: string) => void
}
const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchSiteInfo: (siteId: string) => dispatch(fetchSiteInfo(siteId))
})
interface StateToProps {
  siteInfo: SiteInfoState
}
const mapStateToProps = (state: RootState): StateToProps => ({
  siteInfo: state.siteInfoState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

type AllProps = PropsFromRedux & ParentProps
export default connector(ViewSite)
